import { MenuItemLink } from '../menu-item-data'
import { ReactNode, forwardRef } from 'react'

type MenuAnchorProps = {
  menuItem: MenuItemLink
  children: ReactNode
}

export const MenuAnchor = forwardRef<HTMLAnchorElement, MenuAnchorProps>(
  ({ menuItem, children }, ref): JSX.Element => {
    const target = menuItem.isExternal ? '_blank' : '_self'
    const rel = menuItem.isExternal ? 'noopener,noreferrer' : undefined

    return (
      <a
        onClick={e => {
          // the anchor in the menu is rendered only for SEO,
          // preventDefault prevents the default action (navigate href)
          // from being executed in addition to the javascript action
          // which is handled in MenuContext.visitLink
          e.preventDefault()
        }}
        ref={ref}
        href={menuItem.href}
        target={target}
        rel={rel}
        tabIndex={-1}
      >
        {children}
      </a>
    )
  }
)

MenuAnchor.displayName = 'MenuAnchor'
